import { Fragment } from "react";
import ImageGallery from "./imageGallery";
import "./heroBanner.css";

const HeroBanner = () => {
  return (
    <>
      <div className="BannerHeading">
        <h1>A Safe Space to Talk, Heal, and Grow Because You Deserve It!</h1>
        <h2>Select the Counselling Option That's Right for You.</h2>
      </div>
      <ImageGallery />
    </>
  );
};

export default HeroBanner;
